import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        //minHeight:'100vh',
        scrollBehavior: 'inherit!important',
    },
    content: {
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    grid:{
        //backgroundColor: theme.palette.paper,
    },
    button:{
        width:'100%',
        fontSize:'22px'
    },
    margin:{
        marginBottom: theme.spacing(6),
    }
}));

export default useStyles;

